import { useMutation } from "@tanstack/react-query";
import { createDiamondProduct } from "../api/diamonds";

// Pure mutation hook. Caller owns the redirect inside its per-call
// `onSuccess` so it can flip a "redirecting" flag BEFORE unloading the page
// (keeps the loader visible through navigation, prevents flash).
export default function useCreateDiamondProductMutation() {
    return useMutation({
        mutationFn: (body) => createDiamondProduct(body),
    });
}
